import { type FC, type ReactNode, memo } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: ReactNode;
  container: HTMLElement | null;
}

const BarePortalToContainer: FC<Props> = (props) => {
  if (!props.container) {
    return null;
  }

  return createPortal(props.children, props.container);
};

export const PortalToContainer = memo(BarePortalToContainer);
